module.exports = "/_next/static/images/61de3e4ebdbb38e57e64019eb5cbfc70-phone-with-app-open-and-card@1x-lg.jpg.webp";